document.addEventListener('DOMContentLoaded', () => {

    const init = () => {
        document.documentElement.removeAttribute('style');
        document.documentElement.classList.add('is-loaded');
        
        setTimeout(() => {
            carousels();
            anims();
            document.getElementById('cover').remove();
        }, 250);  
    };
    
    window.addEventListener('load', init);

}, false);